// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Store = require("../../../shared/src/Store.bs.js");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var DateUtils = require("../../../shared/src/DateUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");
var WebStore_Types_Action = require("./WebStore_Types_Action.bs.js");

function reducer(param) {
  var currentDatetime = param[0];
  if (typeof currentDatetime === "number") {
    if (currentDatetime === /* StartCurrentDatetimeUpdate */0) {
      if (param[1].timing.currentDatetimeUpdateInterval !== undefined) {
        return Store.sideEffects(function (_store, dispatch) {
                    return Relude_IO.flatMap((function (param) {
                                  return Curry._1(dispatch, WebStore_Types_Action.timing(currentDatetime));
                                }), Curry._1(dispatch, WebStore_Types_Action.timing(WebStore_Types_Action.Timing.stopCurrentDatetimeUpdate)));
                  });
      } else {
        return Store.sideEffects(function (_store, dispatch) {
                    var partial_arg = Curry._1(Relude_IO.mapError, (function (prim) {
                            
                          }));
                    var partial_arg$1 = function (param) {
                      return Relude_Globals.$great$great((function (param) {
                                    return Relude_Globals.$great$great((function (param) {
                                                  return Relude_Globals.$great$great(WebStore_Types_Action.Timing.setCurrentDatetime, WebStore_Types_Action.timing, param);
                                                }), dispatch, param);
                                  }), partial_arg, param);
                    };
                    var partial_arg$2 = function (param) {
                      return Relude_IO.flatMap(partial_arg$1, param);
                    };
                    var partial_arg$3 = function (param) {
                      return Relude_Globals.$great$great(DateUtils.getNowInIO, partial_arg$2, param);
                    };
                    return Curry._1(dispatch, WebStore_Types_Action.timing(WebStore_Types_Action.Timing.setCurrentDatetimeInterval(setInterval((function (param) {
                                              return Relude_Globals.$great$great(partial_arg$3, IOUtils.unsafeRunHandledAsync, param);
                                            }), 1000))));
                  });
      }
    }
    var state = param[1];
    var timing = state.timing;
    var interval = timing.currentDatetimeUpdateInterval;
    if (interval === undefined) {
      return Store.noUpdate;
    }
    var interval$1 = Caml_option.valFromOption(interval);
    return Store.updateWithSideEffects({
                cities: state.cities,
                currentUser: state.currentUser,
                dashboard: state.dashboard,
                editingShift: state.editingShift,
                layout: state.layout,
                postAShift: state.postAShift,
                savedBusinessAdmins: state.savedBusinessAdmins,
                savedBusinessManagers: state.savedBusinessManagers,
                savedLocations: state.savedLocations,
                token: state.token,
                timing: {
                  currentDatetime: timing.currentDatetime,
                  currentDatetimeUpdateInterval: undefined
                },
                view: state.view
              }, (function (_store, _dispatch) {
                  return Relude_IO.suspend(function (param) {
                              clearInterval(interval$1);
                              
                            });
                }));
  } else {
    if (currentDatetime.TAG === /* SetCurrentDatetime */0) {
      var state$1 = param[1];
      return Store.update({
                  cities: state$1.cities,
                  currentUser: state$1.currentUser,
                  dashboard: state$1.dashboard,
                  editingShift: state$1.editingShift,
                  layout: state$1.layout,
                  postAShift: state$1.postAShift,
                  savedBusinessAdmins: state$1.savedBusinessAdmins,
                  savedBusinessManagers: state$1.savedBusinessManagers,
                  savedLocations: state$1.savedLocations,
                  token: state$1.token,
                  timing: {
                    currentDatetime: currentDatetime._0,
                    currentDatetimeUpdateInterval: state$1.timing.currentDatetimeUpdateInterval
                  },
                  view: state$1.view
                });
    }
    var state$2 = param[1];
    var timing$1 = state$2.timing;
    if (timing$1.currentDatetimeUpdateInterval !== undefined) {
      return Store.sideEffects(function (_store, dispatch) {
                  return Relude_IO.flatMap((function (param) {
                                return Curry._1(dispatch, WebStore_Types_Action.timing(currentDatetime));
                              }), Curry._1(dispatch, WebStore_Types_Action.timing(WebStore_Types_Action.Timing.stopCurrentDatetimeUpdate)));
                });
    } else {
      return Store.update({
                  cities: state$2.cities,
                  currentUser: state$2.currentUser,
                  dashboard: state$2.dashboard,
                  editingShift: state$2.editingShift,
                  layout: state$2.layout,
                  postAShift: state$2.postAShift,
                  savedBusinessAdmins: state$2.savedBusinessAdmins,
                  savedBusinessManagers: state$2.savedBusinessManagers,
                  savedLocations: state$2.savedLocations,
                  token: state$2.token,
                  timing: {
                    currentDatetime: timing$1.currentDatetime,
                    currentDatetimeUpdateInterval: Relude_Option.pure(currentDatetime._0)
                  },
                  view: state$2.view
                });
    }
  }
}

function reducer$1(param, param$1) {
  return Relude_Globals.flip((function (param, param$1) {
                return Relude_Function.curry2(reducer, param, param$1);
              }), param, param$1);
}

var maximumDatetimeUpdateRateMs = 1000;

exports.maximumDatetimeUpdateRateMs = maximumDatetimeUpdateRateMs;
exports.reducer = reducer$1;
/* Store Not a pure module */
